import { Skeleton } from "@mui/material";
export const SkeletonsHorizontalLine = ({ length, height }) => {
  return (
    <div className="w-full flex flex-col gap-3">
      {[...Array(length)].map((_, index) => (
        <Skeleton
          className="w-full rounded-md"
          key={index}
          variant="rectangular"
          height={height}
        />
      ))}
    </div>
  );
};
